export default function IMSystemDemo() {
  return (
    <section className="py-20 px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section title */}
        <div className="text-center mb-12">
          <span className="text-xs font-semibold text-indigo-600 tracking-widest uppercase mb-2 block">System Demo</span>
          <h2 className="text-3xl font-bold text-slate-800 mb-3">系统演示</h2>
          <p className="text-slate-500 text-sm max-w-lg mx-auto">即刻体验招商管理全生命周期数字化平台</p>
        </div>

        {/* Demo preview card */}
        <div className="bg-slate-50 rounded-2xl border border-slate-200 overflow-hidden">
          {/* Card header */}
          <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200 bg-white">
            <div className="flex items-center gap-3">
              <div className="flex items-center gap-1.5">
                <div className="w-3 h-3 rounded-full bg-rose-400"></div>
                <div className="w-3 h-3 rounded-full bg-amber-400"></div>
                <div className="w-3 h-3 rounded-full bg-emerald-400"></div>
              </div>
              <span className="text-slate-500 text-sm font-medium">招商管理平台 · 在线演示</span>
            </div>
            <a
              href="https://readdy.cc/preview/131e7be9-fc84-4c44-9abf-2076789d2f05/10273435/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-indigo-600 hover:text-indigo-700 font-medium flex items-center gap-1 cursor-pointer"
            >
              <i className="ri-external-link-line"></i>
              新窗口打开
            </a>
          </div>

          {/* Iframe container */}
          <div className="relative" style={{ height: 650 }}>
            <iframe
              src="https://readdy.cc/preview/131e7be9-fc84-4c44-9abf-2076789d2f05/10273435/"
              title="招商管理系统演示"
              className="w-full h-full border-0"
              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              loading="lazy"
            />
            {/* Bottom gradient hint */}
            <div className="absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-slate-50 to-transparent pointer-events-none"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
